export default {
  packages: [
    {
      name: "Free",
      type: "monthly",
      priceMonth: "0",
      priceYear: "0",
      lastGreetings: 3,
      biography: 2,
      biographyDescription: "Text only",
      images: 5,
      videos: 1,
      documents: 1,
      likes: "No",
      bookmarks: "No",
      comments: "No",
      imageAndVideoInfo: "No",
      suggestPhoto: "No",
    },
    {
      name: "Basic",
      type: "monthly",
      priceMonth: "2.99",
      priceYear: "29.99",
      lastGreetings: 10,
      biography: 5,
      biographyDescription: "Text only",
      images: 30,
      videos: 2,
      documents: 2,
      likes: "No",
      bookmarks: "No",
      comments: "No",
      imageAndVideoInfo: "No",
      suggestPhoto: "No",
    },
    {
      name: "Plus",
      type: "monthly",
      priceMonth: "6.49",
      priceYear: "64.99",
      lastGreetings: 30,
      biography: 10,
      biographyDescription: "Text and images",
      images: 200,
      videos: 5,
      documents: 10,
      likes: "Yes",
      bookmarks: "No",
      comments: "Yes",
      imageAndVideoInfo: "Yes",
      suggestPhoto: "Yes",
    },
    {
      name: "Pro",
      type: "monthly",
      priceMonth: "10.99",
      priceYear: "109.99",
      lastGreetings: "Unlimited",
      biography: "Unlimited",
      biographyDescription: "Text and images",
      images: 500,
      videos: 10,
      documents: 30,
      likes: "Yes",
      bookmarks: "Yes",
      comments: "Yes",
      imageAndVideoInfo: "Yes",
      suggestPhoto: "Yes",
    },
    {
      name: "Premium",
      type: "monthly",
      priceMonth: "14.99",
      priceYear: "149.99",
      lastGreetings: "Unlimited",
      biography: "Unlimited",
      biographyDescription: "Text, video and images",
      images: 1000,
      videos: 15,
      documents: 50,
      likes: "Yes",
      bookmarks: "Yes",
      comments: "Yes",
      imageAndVideoInfo: "Yes",
      suggestPhoto: "Yes",
    },
    // {
    //   priceMonth: "Custom",
    //   priceYear: "Custom",
    //   name: "Custom",
    //   lastGreetings: "Unlimited",
    //   biography: "Unlimited",
    //   images: "Unlimited",
    //   videos: "Unlimited",
    //   documents: "Unlimited",
    //   likes: "Yes",
    //   bookmarks: "Yes",
    // },
  ],
}